import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Transcript } from '../../models/call-details.model';

@Component({
  selector: 'app-call-details-chat',
  templateUrl: './call-details-chat.component.html',
  styleUrls: ['./call-details-chat.component.scss'],
  providers: [],
})
export class CallDetailsChatComponent {
  @Input() public transcript: Transcript[] = [];
  @Input() public agentFirstName = '';
  @Input() public userFirstName = '';
  @Input() public userLastName = '';
  @Input() public print = false;

  @Output() public jumpToTime = new EventEmitter<number>();

  protected onMessageClick(secondsFromStart: number) {
    this.jumpToTime.emit(Math.max(secondsFromStart - 2, 0));
  }
}
